/**
 * Returns true if value is a string containing non-whitespace characters.
 */
export const isNonEmptyString = (value: unknown): boolean => {
  return typeof value === "string" && value.trim().length > 0;
};
